import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-page">
      <div className="logo-page__glow" aria-hidden="true" />
      <div className="logo-page__blocks" aria-hidden="true" />

      <main className="logo-page__content">
        <h1 className="logo-page__brand">N</h1>
      </main>
    </div>
  );
};

export default Logo;
